import { LogicCashTodayTransactionsServiceMock } from "./logicCashTodayTransactions.types";

export const mockLogicCashTodayTransactionsService = (): LogicCashTodayTransactionsServiceMock => ({
  fetchLogicCashTodayLastTransactionsByLogicCashTodayId: jest.fn(),
});
